import React, { useState } from 'react';
import { Popover, Divider } from '@bufferapp/components';
import { Text, Button } from '@bufferapp/ui';
import { ConfirmModal } from '~/shared-components';
import { useAppDispatch, useAppSelector } from '~/store';
import { cleanQueue } from '~/general-settings/thunks/cleanQueue';
import { selectCurrentProfile } from '~/profile-sidebar/selectors';
import { refreshSingleProfile } from '~/profiles/thunks/fetchSingleProfile';

const cleanQueueWrapperStyle = {
  display: 'flex',
  flexDirection: 'row',
  padding: '0.5rem 0px',
} as const;

const buttonWrapperStyle = {
  marginLeft: '0.5rem',
  minWidth: '175px',
  alignSelf: 'center',
  flex: '0.3 1 0%',
};

const leftContentStyle = {
  flex: '1 1 0%',
};

export const CleanQueueAction = () => {
  const dispatch = useAppDispatch();
  const profile = useAppSelector(selectCurrentProfile);
  const [isModalShowing, setModalShowing] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const showModal = () => setModalShowing(true);
  const hideModal = () => setModalShowing(false);

  // do not show Clean Queue action if there is no profile or user is not manager
  if (!profile?.isManager) return <></>;

  const onConfirmCleanQueue = () => {
    const profileId = profile.id;
    setLoading(true);

    dispatch(cleanQueue({ profileId }))
      .then(() => dispatch(refreshSingleProfile({ profileId })))
      .then(() => {
        setLoading(false);
        hideModal();
      });
  };

  return (
    <div>
      <Divider />
      <div style={cleanQueueWrapperStyle}>
        {isModalShowing && (
          <Popover onOverlayClick={hideModal}>
            <ConfirmModal
              onConfirmClick={onConfirmCleanQueue}
              onCloseModal={hideModal}
              profileService={profile.service}
              avatar={profile.avatarUrl}
              heading="Are you sure?"
              body={`All failed updates in your <span style="font-weight:bold">${profile.serviceUsername}</span> queue will be removed.`}
              btnText={isLoading ? 'Cleaning Queue..' : 'Clean Queue'}
            />
          </Popover>
        )}
        <div style={leftContentStyle}>
          <Text type="h3">Clean Queue</Text>
          <Text type="p">
            Cleaning your queue will remove all <strong>failed updates</strong>{' '}
            within your <strong>{profile.serviceUsername}</strong> queue.
          </Text>
        </div>
        <div style={buttonWrapperStyle}>
          <Button
            fullWidth
            type="primary"
            label="Clean Queue"
            onClick={showModal}
          />
        </div>
      </div>
    </div>
  );
};
